module.exports = __webpack_public_path__ + "img/banner_font.cb2103d0.png";